import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module19World.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from '../../Unit4/Module19/Cotton/CottonPractice';
import PracticeRecording from '../../Unit4/Practice/PracticeRecording';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule9 from '../../FollowTheBeat/FollowTheBeatModule9.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';
const Module19World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);

  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module19 } = useSelector((state) => state.module19, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module19Images/Unit4_Mod4BG_No_Fences.png');
  const monkeyStill = generateImageUrl('images/Module4Images/Monkey+Practice+still.gif');
  const progressbar0 = generateImageUrl('images/Module4Images/ProgressBanana0.png');
  const progressbar1 = generateImageUrl('images/Module4Images/ProgressBanana1.png');
  const progressbar2 = generateImageUrl('images/Module4Images/ProgressBanana2.png');
  const progressbar3 = generateImageUrl('images/Module4Images/ProgressBanana2.png');
  const progressbarCompleted = generateImageUrl('images/Module4Images/Reward_Banana.png');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module4Images/Reward_Banana.png');
  const Hat = generateImageUrl('images/Module19Images/Hat.png');
  const Bowtie = generateImageUrl('images/Module19Images/Bowtie.png');
  const Binoculars = generateImageUrl('images/Module19Images/Binoculars.png');
  const Camera = generateImageUrl('images/Module19Images/Camera.png');
  const JeepBlue = generateImageUrl('images/Module19Images/JeepBlue.png');
  const JeepPink = generateImageUrl('images/Module19Images/JeepPink.png');
  const TrainGreen = generateImageUrl('images/Module19Images/Unit4_Mod4_DailyReward_GreenTrain.svg');
  const TrainOrange = generateImageUrl('images/Module19Images/Unit4_Mod4_DailyReward_OrangeTrain.svg');
  const Parrot = generateImageUrl('images/Module19Images/Parrot.png');
  const Tucan = generateImageUrl('images/Module19Images/Tucan.png');
  const MonkeyCapuchin = generateImageUrl('images/Module19Images/MonkeyCapuchin.png');
  const MonkeyGorilla = generateImageUrl('images/Module19Images/MonkeyGorilla.png');
  const SnakeOrange = generateImageUrl('images/Module19Images/SnakeOrange.png');
  const SnakeGreen = generateImageUrl('images/Module19Images/SnakeGreen.png');
  const StandIceCreamBlue = generateImageUrl('images/Module19Images/Unit4_Mod4_DailyReward_Icecream1@3x.png ');
  const StandIceCreamGreen = generateImageUrl('images/Module19Images/Unit4_Mod4_DailyReward_Icecream2@3x.png ');
  const MonkeySafari = generateImageUrl('images/Module19Images/MonkeyGreen.png');
  const MonkeySunglasses = generateImageUrl('images/Module19Images/MonkeyPink.png');
  const fence = generateImageUrl('images/Module19Images/Unit4_Mod4Fence.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'appfiles/self_advocacy/closing.mp4';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [practice, setPractice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');
  const [animal, setAnimal] = useState(monkeyStill);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [keyAnimationState, setKeyAnimationState] = useState('bounceIcons');
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [monkeyEat, setMonkeyEat] = useState(false);
  const [monkeyEatAudio, setMonkeyEatAudio] = useState(false);
  const [specialMessage, setSpecialMessage] = useState(false);
  const [watchConversation, setWatchConversation] = useState(false);
  const [practiceIntro, setPracticeIntro] = useState('');
  const [practiceIntroAudio, setPracticeIntroAudio] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [animalClose, setAnimalClose] = useState(false);
  const [playAnimalClose, setPlayAnimalClose] = useState(false);
  const [animalCloseAudio, setAnimalCloseAudio] = useState(false);
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [amazingJob, setAmazingJob] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial1_2, setFTBTutorial1_2] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getGifs() {
    setMonkeyEat(getVideo('appfiles/posture/monkey_banana.gif', login));
    setMonkeyEatAudio(getVideo('appfiles/posture/monkey_eating.mp3', login));
    setSpecialMessage(getVideo('appfiles/respond/respond_special_message.gif', login));
    setWatchConversation(getVideo('appfiles/respond/respond_watch_conversation.gif', login));
    setAmazingJob(getVideo('appfiles/respond/respond_amazing_job.gif', login));
    setPracticeIntro(getVideo('appfiles/respond/respond_practice_intro.gif', login));
    setLearnIntro(getVideo('appfiles/respond/respond_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/respond/respond_ftb_intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/respond/respond_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/respond/respond_day_finished.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/self_advocacy/self_advocacy_day_finished.mp3', login));
    setFTBInstruction(getVideo('appfiles/self_advocacy/self_advocacy_ftb_intro.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/respond/respond_ftb_instructions.gif', login));
    setFTBMusic(getVideo('appfiles/respond/respond_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/respond/countingMonkey.gif', login));

    if (!module19.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/self_advocacy/ftb_walkthrough_touch_right_tap_lap.mp3', login));
      setFTBTutorial1_2(getVideo('appfiles/self_advocacy/ftb_walkthrough_touch_left_tap_lap.mp3', login));
      setFTBTutorial2(getVideo('appfiles/manners/ftb_walkthrough_together.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/respond/ftb_walkthrough_audio.mp3', login));
    }
  }

  useEffect(() => {
    getGifs();
  }, []);

  const createGameDetails = (flag, reward, coin) => {
    const game_detail = module19.game_details;
    if (flag) {
      const flags = { flag, lastUpdated: new Date().toJSON() };
      game_detail.moduleFlags.psuh(flags);
    }
    if (coin >= 0) {
      game_detail.tokens_earned = coin;
    }
    if (reward) {
      const dailyRewards = [];
      for (const key in module19.rewards) {
        if (module19.rewards[key].unlocked === true) {
          const rewards = {
            type: key,
            x_multiplier: module19.rewards[key].x,
            y_multiplier: module19.rewards[key].y,
          };
          dailyRewards.push(rewards);
        }
      }
      game_detail.dailyRewards = dailyRewards;
    }
    dispatch({ type: 'MODULE19_SET_GameDetials', payload: game_detail });
  };

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "SelfAdvocacy",
				day_completed: module19.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = async () => {
    const myInit = {
      body: {
        id: module19.moduleID,
        day_completed: module19.day_completed,
        step_completed: module19.stepCompleted,
        game_details: JSON.stringify(module19.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayAnimalClose(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          module19.stepCompleted === 'notstarted' ||
          module19.stepCompleted === 'learn' ||
          module19.stepCompleted === 'practice' ||
          module19.stepCompleted === 'celebrate' ||
          module19.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'SelfAdvocacy',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Account" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module19.stepCompleted]);

    useEffect(() => {
      if((module19.reviewIcon === true || login.grade === "Teacher Account") && module19.sectionCompleted === 4 ) {
          updateProgress();
          module19.sectionCompleted = 0;
      }
    }, [module19.sectionCompleted])

  useEffect(() => {
    if (module19.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module19.coins);
      updateDB();
    }
  }, [module19.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module19.currentday <= module19.day_completed || login.grade === "Teacher Account" || login.grade === "Free Play") {
      if(login.grade === "Teacher Account" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE19_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE19_SET_KEY', payload: 4 });
      if (module19.currentday === 4 || module19.currentday === 8) {
        dispatch({ type: 'MODULE19_SET_KEY', payload: 5 });
      }
    } else {
      if (module19.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE19_TOGGLE_REVIEW_ICON', payload: false });
      if (module19.currentday === 4 && module19.day_completed === 3) {
        if (module19.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 0 });

        } else if (module19.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 1 });

        } else if (module19.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 2 });

        } else if (module19.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 3 });

        } else if (module19.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 4 });
        } else if (module19.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE19_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module19.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 0 });

        } else if (module19.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 1 });
 
        } else if (module19.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 2 });

        } else if (module19.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 3 });

        } else if (module19.stepCompleted === 'celebrate') {
          if (module19.currentday === 8 && module19.day_completed === 7) {
            dispatch({ type: 'MODULE19_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE19_SET_KEY', payload: 4 });
          }
        } else if (module19.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE19_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module19.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);
  let [displayRewardVideo, setDisplayRewardVideo] = useState(false);
  let [rewardVideo, setRewardVideo] = useState('');

  const selectReward = () => {
    return (
      <>
        <div className='rewards'  id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE19_SET_REWARD${module19.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE19_SET_REWARD${module19.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE19_SET_REWARD${module19.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE19_SET_REWARD${module19.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Account" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE19_SET_DAY_UNLOCK${module19.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE19_SET_dayCompleted',
                    payload: module19.currentday === 8 ? 9 : module19.currentday,
                  });
                  dispatch({
                    type: 'MODULE19_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              onError={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  dispatch({
                    type: `MODULE19_SET_DAY_UNLOCK${module19.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE19_SET_dayCompleted',
                    payload: module19.currentday === 8 ? 9 : module19.currentday,
                  });
                  dispatch({
                    type: 'MODULE19_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                let name = '';
                switch (module19.currentday){
                  case 1:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_FoodCart 1.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_FoodCart 2.mp4'
                    }
                    break;
                  case 2:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Item 2.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Item 1.mp4'
                    }
                    break;
                  case 3:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Jeep 1.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Jeep 2.mp4'
                    }
                    break;
                  case 4:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Bird 1.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Bird 2.mp4'
                    }
                    break;
                  case 5:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Train 1.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Train 2.mp4'
                    }
                    break;
                  case 6:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Monkey 2.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Monkey 1.mp4'
                    }
                    break;
                  case 7:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Reptitle 1.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Reptitle 2.mp4'
                    }
                    break;
                  case 8:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Outfit 2.mp4'
                    }
                    else{
                      name = 'media/Module19/Unit4_Mod4_DailyReward_Outfit 1.mp4'
                    }
                    break;
                }
                setRewardVideo(generateImageUrl(name))
                document.getElementById('rewardItemLeft2').style.display = 'none'
                document.getElementById('rewardItemRight2').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={MonkeySafari}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE19_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE19_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={MonkeySunglasses}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE19_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE19_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true)
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE19_SET_COIN',
                    payload: module19.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              onError={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE19_SET_COIN',
                    payload: module19.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                  setRewardVideo(generateImageUrl('media/Module19/Unit4_Mod4_SpecialReward_Dance 2.mp4'))
                }
                else{
                  setRewardVideo(generateImageUrl('media/Module19/Unit4_Mod4_SpecialReward_Dance 1.mp4'))
                }
                document.getElementById('rewardItemLeft').style.display = 'none'
                document.getElementById('rewardItemRight').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module19.currentday) {
      case 1:
        setRewardOption1(StandIceCreamBlue);
        setRewardOption2(StandIceCreamGreen);
        break;
      case 2:
        setRewardOption1(Binoculars);
        setRewardOption2(Camera);
        break;
      case 3:
        setRewardOption1(JeepPink);
        setRewardOption2(JeepBlue);
        break;
      case 4:
        setRewardOption1(Parrot);
        setRewardOption2(Tucan);
        break;
      case 5:
        setRewardOption1(TrainOrange);
        setRewardOption2(TrainGreen);
        break;
      case 6:
        setRewardOption1(MonkeyCapuchin);
        setRewardOption2(MonkeyGorilla);
        break;
      case 7:
        setRewardOption1(SnakeOrange);
        setRewardOption2(SnakeGreen);
        break;
      case 8:
        setRewardOption1(Hat);
        setRewardOption2(Bowtie);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [keyIcon]);

  const displayReview = () => {
    if (module19.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/selfadvocacy/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module19.currentday === 4) {
              dispatch({ type: 'MODULE19_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module19.day_completed === 9) {
              navigate('/selfadvocacy/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/self_advocacy/self_advocacy_demo.m4a', login);
    let video = getVideo(`appfiles/self_advocacy/learn_video.mp4`, login);
    switch (module19.currentday) {
      case 1:
        setLearn(
          <Learn
            video='appfiles/self_advocacy/learn_day_1.mp4'
            songVideo={video}
            closingVideo='appfiles/self_advocacy/learn_day_1_closing.mp4'
            destiny='/selfadvocacy'
            song={song}
            back='/selfadvocacy'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE19_SET_stepCompleted'
            module={module19}
            module19={true}
            animal={animal}
            learnVideo1={'appfiles/self_advocacy/learn_day_1_step_1.mp4'}
            learnVideo2={'appfiles/self_advocacy/learn_day_1_step_2.mp4'}
            learnVideo3={'appfiles/self_advocacy/learn_day_1_step_3.mp4'}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='appfiles/self_advocacy/learn_day_2.mp4'
            songVideo={video}
            closingVideo='appfiles/self_advocacy/learn_day_2_closing.mp4'
            destiny='/selfadvocacy'
            song={song}
            back='/selfadvocacy'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE19_SET_stepCompleted'
            module={module19}
            module19={true}
            animal={animal}
            learnVideo1={'appfiles/self_advocacy/learn_day_1_step_1.mp4'}
            learnVideo2={'appfiles/self_advocacy/learn_day_1_step_2.mp4'}
            learnVideo3={'appfiles/self_advocacy/learn_day_2_step_3.mp4'}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='appfiles/self_advocacy/learn_day_2.mp4'
            songVideo={video}
            closingVideo='appfiles/self_advocacy/learn_day_3_closing.mp4'
            destiny='/selfadvocacy'
            song={song}
            back='/selfadvocacy'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE19_SET_stepCompleted'
            module={module19}
            module19={true}
            animal={animal}
            learnVideo1={'appfiles/self_advocacy/learn_day_1_step_1.mp4'}
            learnVideo2={'appfiles/self_advocacy/learn_day_1_step_2.mp4'}
            learnVideo3={'appfiles/self_advocacy/learn_day_3_step_3.mp4'}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/self_advocacy/self_advocacy_learn_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(learnIntro);
        setShowAnimal(true);
        GetUserVideo(`userfiles/${module19.StudentID}/self_advocacy_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo( `influencers/${influencers[module19.currentday - 4]}/respond_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/selfadvocacy'
                    song={data}
                    back='/selfadvocacy'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE19_SET_stepCompleted'
                    module={module19}
                    instrumental={getVideo('appfiles/self_advocacy/self_advocacy_final.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/selfadvocacy'
                    song={song}
                    back='/selfadvocacy'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE19_SET_stepCompleted'
                    module={module19}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    switch (module19.currentday) {
      case 1:
        setPractice(
          <Practice
            video1={'appfiles/self_advocacy/practice_day_1.mp4'}
            video2={'appfiles/self_advocacy/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE19_SET_stepCompleted'}
            module={module19}
            animal={animal}
          />
        );
        break;
      case 2:
        setPractice(
          <Practice
            video1={'appfiles/self_advocacy/practice_day_2.mp4'}
            video2={'appfiles/self_advocacy/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE19_SET_stepCompleted'}
            module={module19}
            animal={animal}
          />
        );
        break;
      case 3:
        setPractice(
          <Practice
            video1={'appfiles/self_advocacy/practice_day_3.mp4'}
            video2={'appfiles/self_advocacy/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE19_SET_stepCompleted'}
            module={module19}
            animal={animal}
          />
        );
        break;
      default:
        const optionThink = {
          img: generateImageUrl('images/Module19Images/practice/Think about what you want to say.png'),
          title: 'Think about what you want to say or do',
          audioPrompt: 'appfiles/self_advocacy/option_think_about_what_to_say.mp3',
        };

        const optionBelieve = {
          img: generateImageUrl('images/Module19Images/practice/belieive in yourself.png'),
          title: 'Believe in yourself',
          audioPrompt: 'appfiles/self_advocacy/option_believe_in_self.mp3',
        };

        const optionAchieve = {
          img: generateImageUrl('images/Module19Images/practice/achieve it.png'),
          title: 'Achieve it',
          audioPrompt: 'appfiles/self_advocacy/option_achieve_it.mp3',
        };

        // MARK: Day 4

        const birdShowThinkBubble = {
          text: 'I want to ask my friend to go to the bird show with me',
          phrase: 'appfiles/self_advocacy/practice_bird_speechbubble_think.mp3',
        };

        const birdShowBelieveBubble = {
          text: 'I believe I can tell my teacher I am going to the bird show!',
          phrase:
            'appfiles/self_advocacy/practice_bird_speechbubble_believe.mp3',
        };

        const birdShowAchieveBubble = {
          text: 'Can I feed the birds?',
          phrase:
            'appfiles/self_advocacy/practice_bird_speechbubble_achieve.mp3',
        };

        const birdShowThink = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionThink,
          incorrectMatches: [optionBelieve, optionAchieve],
          speechBubble: birdShowThinkBubble,
          animal: generateImageUrl('images/Module1Images/Crab.svg'),
        };

        const birdShowBelieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionBelieve,
          incorrectMatches: [optionThink, optionAchieve],
          speechBubble: birdShowBelieveBubble,
          animal: generateImageUrl('images/Module19Images/practice/dog.png'),
        };

        const birdShowAchieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionAchieve,
          incorrectMatches: [optionThink, optionBelieve],
          speechBubble: birdShowAchieveBubble,
          animal: generateImageUrl('images/Module19Images/practice/staff_bird.png'),
        };

        // // MARK: Day 5

        const trainRideThinkBubble = {
          text: 'I want to ask the zoo worker where to buy the train ticket',
          phrase:
            'appfiles/self_advocacy/practice_train_speechbubble_think.mp3',
        };

        const trainRideBelieveBubble = {
          text: 'I believe I can ask my friend to go on the train ride with me',
          phrase:
            'appfiles/self_advocacy/practice_train_speechbubble_believe.mp3',
        };

        const trainRideAchieveBubble = {
          text: 'How long is the train ride?',
          phrase:
            'appfiles/self_advocacy/practice_train_speechbubble_achieve.mp3',
        };

        const trainRideThink = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionThink,
          incorrectMatches: [optionBelieve, optionAchieve],
          speechBubble: trainRideThinkBubble,
          animal: generateImageUrl('images/Module19Images/practice/staff_bird.png'),
        };

        const trainRideBelieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionBelieve,
          incorrectMatches: [optionThink, optionAchieve],
          speechBubble: trainRideBelieveBubble,
          animal: generateImageUrl('images/Module1Images/Crab.svg'),
        };

        const trainRideAchieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionAchieve,
          incorrectMatches: [optionThink, optionBelieve],
          speechBubble: trainRideAchieveBubble,
          animal: generateImageUrl('images/Module19Images/practice/dog.png'),
        };

        // MARK: Day 6

        const monkeysThinkBubble = {
          text: 'I want to tell my teacher that I need to sit down in the shade for a bit',
          phrase:
            'appfiles/self_advocacy/practice_monkey_speechbubble_think.mp3',
        };

        const monkeysBelieveTrainerBubble = {
          text: 'I believe I can ask the zoo worker how they train the monkeys',
          phrase:
            'appfiles/self_advocacy/practice_monkey_speechbubble_believe.mp3',
        };

        const monkeysAchieveClassmatesBubble = {
          text: 'Do you want to look at the monkeys with me?',
          phrase:
            'appfiles/self_advocacy/practice_monkey_speechbubble_achieve.mp3',
        };

        const monkeysThink = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionThink,
          incorrectMatches: [optionBelieve, optionAchieve],
          speechBubble: monkeysThinkBubble,
          animal: generateImageUrl('images/Module19Images/practice/dog.png'),
        };

        const monkeysBelieveTrainer = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionBelieve,
          incorrectMatches: [optionThink, optionAchieve],
          speechBubble: monkeysBelieveTrainerBubble,
          animal: generateImageUrl('images/Module19Images/practice/staff_bird.png'),
        };

        const monkeysAchieveClassmates = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionAchieve,
          incorrectMatches: [optionThink, optionBelieve],
          speechBubble: monkeysAchieveClassmatesBubble,
          animal: generateImageUrl('images/Module1Images/Crab.svg'),
        };

        // // MARK: Day 7

        const reptilesThinkBubble = {
          text: 'I want to ask the zoo worker for help to find my teacher',
          phrase:
            'appfiles/self_advocacy/practice_reptiles_speechbubble_think.mp3',
        };

        const reptilesBelieveBubble = {
          text: 'I believe I can ask my friend to please move over so I can see',
          phrase:
            'appfiles/self_advocacy/practice_reptiles_speechbubble_believe.mp3',
        };

        const reptilesAchieveBubble = {
          text: 'Can I use the restroom please?',
          phrase:
            'appfiles/self_advocacy/practice_reptiles_speechbubble_achieve.mp3',
        };

        const reptilesThink = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionThink,
          incorrectMatches: [optionBelieve, optionAchieve],
          speechBubble: reptilesThinkBubble,
          animal: generateImageUrl('images/Module19Images/practice/staff_bird.png'),
        };

        const reptilesBelieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionBelieve,
          incorrectMatches: [optionThink, optionAchieve],
          speechBubble: reptilesBelieveBubble,
          animal: generateImageUrl('images/Module1Images/Crab.svg'),
        };

        const reptilesAchieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionAchieve,
          incorrectMatches: [optionThink, optionBelieve],
          speechBubble: reptilesAchieveBubble,
          animal: generateImageUrl('images/Module19Images/practice/dog.png'),
        };

        // MARK: Day 8

        const snacksThinkBubble = {
          text: 'I want to ask my friend to go to the snack shack with me',
          phrase:
            'appfiles/self_advocacy/practice_snack_speechbubble_think.mp3',
        };

        const snacksBelieveBubble = {
          text: 'I believe I can ask my teacher if I can buy a snow cone',
          phrase:
            'appfiles/self_advocacy/practice_snack_speechbubble_believe.mp3',
        };

        const snacksAchieveBubble = {
          text: 'Can I please have an extra napkin?',
          phrase:
            'appfiles/self_advocacy/practice_snack_speechbubble_achieve.mp3',
        };

        const snacksThink = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionThink,
          incorrectMatches: [optionBelieve, optionAchieve],
          speechBubble: snacksThinkBubble,
          animal: generateImageUrl('images/Module1Images/Crab.svg'),
        };

        const snacksBelieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionBelieve,
          incorrectMatches: [optionThink, optionAchieve],
          speechBubble: snacksBelieveBubble,
          animal: generateImageUrl('images/Module19Images/practice/dog.png'),
        };

        const snacksAchieve = {
          audioPrompt:
            'appfiles/self_advocacy/practice_what_step_monkey_doing.mp3',
          correctMatch: optionAchieve,
          incorrectMatches: [optionThink, optionBelieve],
          speechBubble: snacksAchieveBubble,
          animal: generateImageUrl('images/Module19Images/practice/staff_bird.png'),
        };

        const options = [
          [birdShowThink, birdShowBelieve, birdShowAchieve],
          [trainRideThink, trainRideBelieve, trainRideAchieve],
          [monkeysThink, monkeysBelieveTrainer, monkeysAchieveClassmates],
          [reptilesThink, reptilesBelieve, reptilesAchieve],
          [snacksThink, snacksBelieve, snacksAchieve],
        ];
        const numArray = options[module19.currentday - 4]
          .map((value) => ({ value, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map(({ value }) => value);
        const titles = [
          'What step is the monkey doing?',
          'What step is the monkey doing?',
          'What step is the monkey doing?',
        ];
        const names = [
          [
            'self_advocacy_practice_greet_5.mp4',
            'self_advocacy_practice_close_5.mp4',
          ],
          [
            'self_advocacy_practice_greet_6.mp4',
            'self_advocacy_practice_close_6.mp4',
          ],
          [
            'self_advocacy_practice_greet_7.mp4',
            'self_advocacy_practice_close_7.mp4',
          ],
          [
            'self_advocacy_practice_greet_8.mp4',
            'self_advocacy_practice_close_8.mp4',
          ],
          [
            'self_advocacy_practice_greet_9.mp4',
            'self_advocacy_practice_close_9.mp4',
          ],
        ];
        const instructions = [
          [
            'appfiles/self_advocacy/practice_birdshow_greet.mp4',
            'appfiles/self_advocacy/practice_birdshow_answer.mp4',
            'appfiles/self_advocacy/practice_birdshow_close.mp4',
          ],
          [
            'appfiles/self_advocacy/practice_train_greet.mp4',
            'appfiles/self_advocacy/practice_train_answer.mp4',
            'appfiles/self_advocacy/practice_train_close.mp4',
          ],
          [
            'appfiles/self_advocacy/practice_monkey_greet.mp4',
            'appfiles/self_advocacy/practice_monkey_answer.mp4',
            'appfiles/self_advocacy/practice_monkey_close.mp4',
          ],
          [
            'appfiles/self_advocacy/practice_reptiles_greet.mp4',
            'appfiles/self_advocacy/practice_reptiles_answer.mp4',
            'appfiles/self_advocacy/practice_reptiles_close.mp4',
          ],
          [
            'appfiles/self_advocacy/practice_snacks_greet.mp4',
            'appfiles/self_advocacy/practice_snacks_answer.mp4',
            'appfiles/self_advocacy/practice_snacks_close.mp4',
          ]
        ];
        const texts = [
          [
            `Press record and say, "It is good to meet you. Can I feed the birds, please?"`,
            `Press record and say, "You are welcome. Bye!"`,
          ],
          [
            `Press record and say, "Hi! Can you please tell me where I can buy a train ticket?"`,
            `Press record and say, "Thanks, and have a good day!"`,
          ],
          [
            `Press record and say, "Hello! What do monkeys like to eat?"`,
            `Press record and say, "Thanks!"`,
          ],
          [
            `Press record and say, "Hi! Can you help me find my teacher?"`,
            `Press record and say, "Thank you so much!"`,
          ],
          [
            `Press record and say, "Hi! Can I get a napkin, please?"`,
            `Press record and say, "Thank you so much. Bye!"`,
          ],
        ];
        const voices = [
          [
            'appfiles/self_advocacy/practice_birdshow_greet_prompt.m4a',
            'appfiles/self_advocacy/practice_birdshow_close_prompt.mp3',
          ],
          [
            'appfiles/self_advocacy/practice_train_greet_prompt.mp3',
            'appfiles/self_advocacy/practice_train_close_prompt.mp3',
          ],
          [
            'appfiles/self_advocacy/practice_monkey_greet_prompt.mp3',
            'appfiles/self_advocacy/practice_monkey_close_prompt.mp3',
          ],
          [
            'appfiles/self_advocacy/practice_reptile_greet_prompt.mp3',
            'appfiles/self_advocacy/practice_reptile_close_prompt.mp3',
          ],
          [
            'appfiles/self_advocacy/practice_snack_greet_prompt.mp3',
            'appfiles/self_advocacy/practice_snack_close_prompt.mp3',
          ]
        ];
        const exampleVideos = [
          'f06b82cae82f3db9ed5f8f897105/480.m3u8',
          '9550b4175a782c9389044a6ec646/480.m3u8',
          'c5d12c682e57d21a4af35c6b9f72/480.m3u8',
          'ca7ad958f25622f7befcd5a1cc35/480.m3u8',
          '73a5fde4b0fe966c33648df9d5f2/480.m3u8',
        ];
        setAnimalVoice(getVideo('appfiles/self_advocacy/self_advocacy_practice_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(practiceIntro);
        setShowAnimal(true);
        setPractice(
          <PracticeRecording
            score={'practice_self_advocacy'}
            score_target={3}
            options={numArray}
            titles={titles}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE19_SET_stepCompleted'}
            module={module19}
            animal={
              generateImageUrl('images/Module19Images/practice/U4M5_Monkey_Happy.png')
            }
            module19={true}
            instructions={instructions[module19.currentday - 4]}
            names={names[module19.currentday - 4]}
            texts={texts[module19.currentday - 4]}
            voices={voices[module19.currentday - 4]}
            influencerid={influencers[module19.currentday - 4]}
            introduction={practiceIntro}
            introductionMP3={
              'appfiles/resolve_conflict/practice_conversation.mp3'
            }
            practiceConversation={watchConversation}
            practiceMessage={specialMessage}
            awesomeJob={amazingJob}
            bigAnimal={true}
            practiceConversationAudio={'media/Module16/watch_conversation.mp3'}
            practiceMessageAudio={'appfiles/respond/respond_practice_special_message.mp3'}
            awesomeJobAudio={'appfiles/respond/respond_amazing_job.mp3'}
            exampleVideo={exampleVideos[module19.currentday - 4]}
          />
        );
        break;
    }
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    switch (module19.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;
      default:
        setDisplayFTB(true);
        setAnimalVoice(getVideo('appfiles/respond/respond_ftb_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(ftbIntro);
        setShowAnimal(true);
        break;
    }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'appfiles/self_advocacy/celebrate_day_1.mp4';
    const celebrateVideo2 = 'appfiles/self_advocacy/celebrate_day_1.mp4';
    const celebrateVideo3 = 'appfiles/self_advocacy/celebrate_day_1.mp4';

    switch (module19.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module19}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE19'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module19}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE19'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module19}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE19'}
          />
        );
        break;
      default:
        let audios = ['appfiles/self_advocacy/self_advocacy_celebrate_record_think.mp3',
        'appfiles/self_advocacy/self_advocacy_celebrate_record_believe.mp3',
        'appfiles/self_advocacy/self_advocacy_celebrate_record_achieve.mp3',
        'appfiles/self_advocacy/self_advocacy_celebrate_record_speak_up.mp3',
        'appfiles/self_advocacy/self_advocacy_celebrate_record_stand_up.mp3']
        let text = [`Record yourself in an excited voice and say, "I can do it all, because I think about what I want to say or do!"`,
        `Record yourself in an excited voice and say, "I can do it all, because I believe in myself!"`,
        `Record yourself in an excited voice and say, "I can do it all, because I achieve great things!"`,
        `Record yourself in an excited voice and say, "I can do it all, because I can speak up for myself!"`,
        `Record yourself in an excited voice and say, "I can do it all, because I can stand up for myself!"`]
        setAnimalVoice(getVideo('appfiles/respond/respond_celebrate_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(celebrateIntro);
        setShowAnimal(true);
        let voice1 = getVideo(audios[module19.currentday-4], login)
        let voice2 = getVideo('appfiles/respond/respond_celebrate_say_yes.mp3', login)
        let voice3 = getVideo('appfiles/respond/respond_amazing_job.mp3', login)
        let animalGIF = getVideo('appfiles/solutions/joyful monkey.gif', login)
        let animalVoice = getVideo('appfiles/solutions/monkey_joyful_jingle_intro.mp3', login)
        await GetUserVideo(`influencers/${influencers[module19.currentday - 4]}/respond_affirmation.mp4`).then((influencerVideo) => {
        setCelebrate(
          <Celebrate
            world3={true}
            module={module19}
            background={background}
            voice1={voice1}
            voice2={voice2}
            voice3={voice3}
            animalGIF={animalGIF}
            animalVoice={animalVoice}
            text={text[module19.currentday-4]}
            name={`self_advocacy_celebration_surprise_${
              module19.currentday + 1
            }.mp4`}
            influencerVideo={influencerVideo}
            animation={amazingJob}
            animal={animal}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE19'}
            bigAnimal={true}
          />
        );
      });
           
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = getVideo('appfiles/resolve_conflict/singing_time.mp4', login);
    const noteVideo = getVideo('appfiles/self_advocacy/self_advocacy_student_notes.mp4', login);
    const singingMusic = getVideo('appfiles/self_advocacy/self_advocacy_demo.m4a', login);
    const instrumental = getVideo('appfiles/self_advocacy/self_advocacy_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module19}
        moduleNum='MODULE19'
        name='self_advocacy'
        instrumental={instrumental}
        instrumentalURL={'appfiles/self_advocacy/self_advocacy_final.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid}/respond_affirmation.mp4`,
      },
      {
        video: 'appfiles/self_advocacy/practice_birdshow_greet.mp4',
      },
      {
        video: `userfiles/${module19.StudentID}/self_advocacy_practice_greet_5.mp4`,
      },
      {
        video: 'appfiles/self_advocacy/practice_birdshow_answer.mp4',
      },
      {
        video: `userfiles/${module19.StudentID}/self_advocacy_practice_close_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/conversation_affirmation.mp4`,
      },
      {
        video: `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_6.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/respond_affirmation.mp4`,
      },
      {
        video: `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/respond_video_message.mp4`,
      },
      {
        video: `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_8.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/respond_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; ++i){
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
  
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/self_advocacy/self_advocacy_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const rewardAnimation = () => {
    setKeyAnimationState('fade-out');
    sleep(1000).then(() => {
      setKeyIcon(false);
      setAnimalVoice(monkeyEatAudio);
      // setDisplayVoice(true);
      setAnimalState(monkeyEat);
      setShowAnimal(true);
      sleep(3000).then(() => {
        setRewardsFound(true);
        setDisplayReward(true);
      });
    });
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(getVideo(AfterCelebrateVideo9, login));
  };

  const playButtonAudio = () => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE19_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE19_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setShowAnimal(false);
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayVoice]);

  useEffect(() => {
    let timer;
    if(playAnimalClose && isIOS()) {
      timer = setTimeout(() => {
        setPlayAnimalClose(false);
        if(module19.currentday === 8) {
          closeDay9Video();
        } else {
          navigate('/selfadvocacy/navigation');
        }
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [playAnimalClose]);

  useEffect(() => {
    let timer;
    if(coinAudio && isIOS()) {
      timer = setTimeout(() => {
        dispatch({ type: 'MODULE19_SET_COIN', payload: module19.coins + 1 });
        setCoinAudio(false);
        setCoinAnimationState('bounceIcons');
        setCoinIcon(false);
        playButtonAudio();
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [coinAudio]);

  return (
    <>
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE19_SET_COIN',
              payload: module19.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playAnimalClose && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayAnimalClose(false);
            module19.currentday === 8
              ? closeDay9Video()
              : navigate('/selfadvocacy/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
            document.getElementById('stillMonkey').style.display = 'none';
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setAnimalState('');
            setShowAnimal(false);
            setAnimal(monkeyStill);
            document.getElementById('stillMonkey').style.display = 'block';
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {!showAnimal && displayPractice && practice}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule9
          unit4={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial1_2={ftbTutorial1_2}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE19_SET_stepCompleted'} 
          module={module19}
          score={'ftb_self_advocacy'}
        />
      )}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySingingTime && singTime}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='respondWorldBody'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world Image'
              onClick={() => {
                navigate('/selfadvocacy/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}
          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                sleep(1400).then(() => {
                  sleep(1000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='monkey9' id='stillMonkey' src={animal} alt='monkey Icon' />
          <img className='fence'  src={fence} alt='fence Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              className='animatedMonkey'
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              alt='monkey Icon'
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'

            />
            {module19.coins < 10 && (
              <h5 className='scoretext1'>{module19.coins}</h5>
            )}
            {module19.coins >= 10 && module19.coins < 100 && (
              <h5 className='scoretext10'>{module19.coins}</h5>
            )}
            {module19.coins >= 100 && (
              <h5 className='scoretext100'>{module19.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module19.currentday === 4 || module19.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey4'
                src={keys5[module19.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module19.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey4'
                src={keys4[module19.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module19.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module19.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module19.currentday === 4 &&
                  module19.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module19.currentday !== 4 &&
                  module19.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module19.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={practiceBtn}
                    alt='practice button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}

                {module19.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={ftbBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}

                {module19.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={celebrateBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}

                {module19.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module19.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            (
              <div className='actionBtnDiv'>
                {module19.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        rewardAnimation();
                      });
                    }}
                />)}
                {module19.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon &&
            keyIcon &&
            !disPlayPrize &&
            module19.reviewIcon === false && (
              <img
                id={keyAnimationState}
                className='keyRewards'
                style={{
                  width: '150px',
                  height: '50px',
                  marginLeft: '-75px',
                  zIndex: 100,
                }}
                src={keyReward}
                alt='reward key'
                onClick={() => {
                  rewardAnimation();
                }}
              />
            )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module19.rewards.Hat.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.Hat.x * clientWidth,
                  y: module19.rewards.Hat.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${Hat})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.Bowtie.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.Bowtie.x * clientWidth,
                  y: module19.rewards.Bowtie.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveCharaterReward29'
                  style={{ backgroundImage: `url(${Bowtie})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.Binoculars.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.Binoculars.x * clientWidth,
                  y: module19.rewards.Binoculars.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveBinoculars1'
                  style={{ backgroundImage: `url(${Binoculars})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.Camera.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.Camera.x * clientWidth,
                  y: module19.rewards.Camera.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveCamera2'
                  style={{ backgroundImage: `url(${Camera})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.JeepBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.JeepBlue.x * clientWidth,
                  y: module19.rewards.JeepBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveBigReward2'
                  style={{ backgroundImage: `url(${JeepBlue})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.JeepPink.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.JeepPink.x * clientWidth,
                  y: module19.rewards.JeepPink.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveBigReward1'
                  style={{ backgroundImage: `url(${JeepPink})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.TrainGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.TrainGreen.x * clientWidth,
                  y: module19.rewards.TrainGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveTrain2'
                  style={{ backgroundImage: `url(${TrainGreen})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.TrainOrange.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.TrainOrange.x * clientWidth,
                  y: module19.rewards.TrainOrange.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveTrain1'
                  style={{ backgroundImage: `url(${TrainOrange})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.Tucan.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.Tucan.x * clientWidth,
                  y: module19.rewards.Tucan.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveSmallReward26'
                  style={{ backgroundImage: `url(${Tucan})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.Parrot.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.Parrot.x * clientWidth,
                  y: module19.rewards.Parrot.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveSmallReward16'
                  style={{ backgroundImage: `url(${Parrot})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.MonkeyCapuchin.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.MonkeyCapuchin.x * clientWidth,
                  y: module19.rewards.MonkeyCapuchin.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='moveReward19'
                  style={{ backgroundImage: `url(${MonkeyCapuchin})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.MonkeyGorilla.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.MonkeyGorilla.x * clientWidth,
                  y: module19.rewards.MonkeyGorilla.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${MonkeyGorilla})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.SnakeOrange.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.SnakeOrange.x * clientWidth,
                  y: module19.rewards.SnakeOrange.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveSnake1'
                  style={{ backgroundImage: `url(${SnakeOrange})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.SnakeGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.SnakeGreen.x * clientWidth,
                  y: module19.rewards.SnakeGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveSnake2'
                  style={{ backgroundImage: `url(${SnakeGreen})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.StandIceCreamBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.StandIceCreamBlue.x * clientWidth,
                  y: module19.rewards.StandIceCreamBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveCart1'
                  style={{ backgroundImage: `url(${StandIceCreamBlue})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.StandIceCreamGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.StandIceCreamGreen.x * clientWidth,
                  y: module19.rewards.StandIceCreamGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveCart2'
                  style={{ backgroundImage: `url(${StandIceCreamGreen})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.MonkeySafari.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.MonkeySafari.x * clientWidth,
                  y: module19.rewards.MonkeySafari.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(1, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${MonkeySafari})` }}
                ></div>
              </Draggable>
            )}

            {module19.rewards.MonkeySunglasses.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module19.rewards.MonkeySunglasses.x * clientWidth,
                  y: module19.rewards.MonkeySunglasses.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(2, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${MonkeySunglasses})` }}
                ></div>
              </Draggable>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Module19World;
